import { RouterStore } from 'mobx-react-router';
import { action } from "mobx";
import AjaxService from 'Services/ajax-service'
import { onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse } from 'Services/network-config'
import { UserInfoStore } from '@sogei/agenzia-entrate-common'
import MenuStore from './menu-store'
import HomeStore from './home-store'
import ErrorStore from './error-store'
import UiStore from './ui-store';
import InfoStore from './registrazioneStore/info-store';


class RootStore {
  constructor() {
    this.service = new AjaxService(this, onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse)

    this.uiStore = new UiStore(this)

    this.userInfoStore = new UserInfoStore(this)
    this.menuStore = new MenuStore(this)
    this.errorStore = new ErrorStore(this)
    this.homeStore = new HomeStore(this)

    this.infoStore = new InfoStore(this)
    

    this.routingStore = new RouterStore();
  }

  @action
  refreshStore(listeExcludeStore) {
    //inizializza a false tutte le proprietà degli store che si chiamano  'fetched'
    console.log('refresh all stores ....')
    let appo = [];

    if (listeExcludeStore)
      appo = listeExcludeStore;

    appo.push('service');
    appo.push('routingStore');
    //appo.push('userInfoStore');

    let stores = Object.keys(this).filter(item => !appo.includes(item))
    for (let store of stores) {
      console.log('refresh store ' + store)
      this[store].fetched = false
    }
  }
}

export default RootStore;